// extracted by mini-css-extract-plugin
export default {"cancelledQuantity":"operationItemsTable_cancelledQuantity__UjqA9","tooltip":"operationItemsTable_tooltip__BaJyS"};